/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTruckGarbageSideView: {
  name: 'truck-garbage-side-view';
  data: string;
} = {
  name: 'truck-garbage-side-view',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.414 3A2 2 0 0 0 12 3.586l-1.54 1.54-5.45 1.817a2 2 0 0 0-1.032.788L2.46 10.008a2 2 0 0 0-.193 1.852L3.523 15H3a1 1 0 1 0 0 2h.17a3 3 0 1 0 5.659 0H15c.058 0 .116-.003.173-.007a3 3 0 1 0 5.597-.146A2 2 0 0 0 22 15v-2.52a2 2 0 0 0-.75-1.561L17 7.519V5h2a1 1 0 1 0 0-2h-5.586Zm0 2H15v10H5.677l-1.553-3.883L5.642 8.84l5.45-1.817a2 2 0 0 0 .782-.483L13.414 5ZM20 15v-2.52l-3-2.4V15h3Zm-2 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM5 18a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z" fill="currentColor"/></svg>`,
};
